import { TextField } from "@mui/material";
import { styled } from "@mui/system";
import { roundedTextFieldStyles } from "./roundedTextFieldStyles";

const RoundedPhoneTextField = styled(TextField)({
  ...roundedTextFieldStyles,
  "& .MuiOutlinedInput-root": {
    ...roundedTextFieldStyles["& .MuiOutlinedInput-root"],
    "& .MuiInputBase-formControl": {
      borderRadius: 0,
      background: "transparent !important",
      border: "0 !important",
      "& .MuiOutlinedInput-notchedOutline": {
        border: "0 !important",
      },
    },
  },
  "& .MuiInputBase-input": {
    ...roundedTextFieldStyles["& .MuiInputBase-input"],
    padding: "15px 10px",
    "&::placeholder": {
      color: "#151516",
    },
  },
});

export default RoundedPhoneTextField;
